// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Message = function Message(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.25 14.376c1.035 0 1.875.84 1.875 1.874v.625l2.832-2.124a1.88 1.88 0 0 1 1.125-.375H17.5a.627.627 0 0 0 .625-.625V2.5a.627.627 0 0 0-.625-.626h-15a.627.627 0 0 0-.625.625v11.25c0 .344.281.626.625.626zm1.875 4.843-.008.008-.199.148-.668.5a.63.63 0 0 1-.656.06.62.62 0 0 1-.344-.56V16.25H2.5a2.5 2.5 0 0 1-2.5-2.5V2.5C0 1.122 1.121 0 2.5 0h15C18.879 0 20 1.122 20 2.5v11.25c0 1.38-1.121 2.5-2.5 2.5h-5.418z"
  }));
};
